import { render, staticRenderFns } from "./SettingsApp.vue?vue&type=template&id=ebf6e9f2"
import script from "./SettingsApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsApp.vue?vue&type=style&index=0&id=ebf6e9f2&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports